<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title><v-icon color="secondary">mdi-folder</v-icon> {{ folder.folderName }} freigeben
        <v-spacer/>
        <IconTooltipButtonBottom
          icon="mdi-close"
          tooltip="Schließen"
          id="default"
          @click="close()"
        />
      </v-card-title>
      <div>
        <div v-for="user in users" :key="user.id">
          <v-list-item>
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-checkbox v-model="selectedUsers" :value="user.userId"></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{user.fullName}}</v-list-item-title>
              <v-list-item-subtitle>{{ user.userId }} | {{ user.roles.map(role => role.roleTitle).join(', ') }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-list-item>
        </div>
      </div>
      <v-btn v-if="selectedUsers.length == 0" class="dialogButton" color="error" medium elevation="0" @click="shareFolder">
        <v-icon color="#F5F5F5" medium>mdi-folder-remove-outline</v-icon >Freigabe wiederrufen
      </v-btn>
      <v-btn v-else :disabled="selectedUsers.length < 1" class="dialogButton" color="primary" medium elevation="0" @click="shareFolder">
        <v-icon color="#F5F5F5" medium>mdi-folder-upload-outline</v-icon >Ordner freigeben
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom.vue";
import userService from "@/components/userService.js";
import folderService from "../../components/folder-service";
export default {
  components: {
    IconTooltipButtonBottom
  },
  computed: {
    show: {
      cache: false,
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
  },
  data() {
    return {
      folder: null,
      users: [],
      dialog: false,
      selectedUsers: [],
      linkCreated: false,
      shareLink: null,
      loaded: false,
      reject: null,
      resolve: null,
      selected: []
    };
  },
  methods: {
    open(folder){
      this.folder = folder;
      this.users = [];
      userService.retrieveUsers().then(allUsers => {
        this.users = allUsers.data;
        this.dialog = true;
  
        folderService.getSharedUsersForFolder(this.folder.id).then(res => {
          this.selectedUsers = res.data != null ? res.data : [];
        })
        /* processModelingService.retrieveSharedUsers(this.uuid).then((sharedUsers) => {
          allUsers.data.forEach( user => {
            if (!(sharedUsers.data.find(sharedUser => sharedUser.userId === user.userId))) {
              user.fullName = user.firstName+' '+user.lastName;
              this.users.push(user);
            }
          })

        }); */
      });
    return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close(){
      this.selectedUsers = [];
      this.reject();
      this.dialog = false;
    },
    shareFolder() {
      folderService.shareFolderWithUsers(this.folder.id, this.selectedUsers).then(res => {
        this.selectedUsers = [];
        this.resolve();
        this.dialog = false;
      })
    }
  }
};
</script>
<style>
:deep .v-text-field__details {
  display: none !important;
}
</style>